import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"

const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const getAllPartnerActionNoLimit = createAsyncThunk(
    'all-partner-no-limit',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/admins/api/getAllPartnerNoLimit`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const allPartnerNoLimitSlice = createSlice({
    name: 'all-partner-no-limit',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getAllPartnerActionNoLimit.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getAllPartnerActionNoLimit.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.totalPages = action?.payload?.totalPages
            })
            builder.addCase(getAllPartnerActionNoLimit.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const allPartnerNoLimitReducer = allPartnerNoLimitSlice.reducer